<template>
    <div>
        <div class="post__categories d-flex mt-3">
            <category-badge 
                :category="post.category"
            />
        </div>
        <div class="d-flex justify-content-between mt-4">
            <ul class="post__likes d-flex list-unstyled align-items-center">
                <li>
                    <img src="/assets/images/icons/hand-dislike.svg" alt="">
                </li>
                <li>
                    <span v-text="followsCount"></span>
                </li>
                <li>
                    <img src="/assets/images/icons/hand-like.svg" alt="">
                </li>
            </ul>
            <post-widgets :post="post"></post-widgets>
        </div>
    </div>
</template>

<script>

import PostWidgets from './PostWidgets'
import CategoryBadge from '../CategoryBadge'

export default {
    name: "PostInfo",
    components: { PostWidgets, CategoryBadge },
    props: {
        post: { required: true, type: Object },
    },

    computed: {
        followsCount(){
            let { follows_count } = this.post
            return follows_count > 0 ? `+${follows_count}` : follows_count
        }
    }

}
</script>

<style>

</style>